import React from 'react';
import PropTypes from 'prop-types';
import Input from '../../Input';
import styles from './styles.less';

const Period = ({ t, updateContent, periodValue, period, freeCourse }) => (
  <>
    {period === 'custom' && (
      <div className={styles.cusomPeriodInput}>
        <Input
          version="long"
          size="large"
          disabled={freeCourse}
          placeholder={t('course.edit.price.period')}
          onChange={e => updateContent('period_value', e.target.value)}
          value={periodValue}
          maxLength={40}
        />
        <p>{t('max.length.40.characters')}</p>
      </div>
    )}
  </>
);

Period.propTypes = {
  updateContent: PropTypes.func,
  t: PropTypes.func,
  periodValue: PropTypes.string,
  period: PropTypes.string,
  freeCourse: PropTypes.bool,
};

Period.defaultProps = {
  updateContent: () => {},
  t: () => {},
  periodValue: '',
  period: '',
  freeCourse: '',
};

export default Period;
